import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './Components/NavBarComp/Navbar';
import Footer from './Components/FooterComp/Footer';
import Home from './Components/HomeComp/Home';
import Products from './Components/ProductsComp/Products';
import Careers from './Components/CareersComp/Careers';
import ContactUs from './Components/ContactUsComp/Contactus';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <NavBar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
